export default "__VITE_ASSET__wBe4Cvlb__"